import { useEffect } from 'react';
import Title from 'components/Title';
import { RootState } from 'redux/store';
import { Link, useNavigate } from 'react-router-dom';
import { Table } from 'components/Table';
import { Card, Col, Row, Badge, Button } from 'react-bootstrap';
import { getStores } from 'redux/slices/Stores';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getStoreGroups } from 'redux/slices/Accounts';
import { getFeatureFlagValue } from 'components/ZFeatureFlag';
import { ZTooltip } from 'components/ZTooltip';
import { ZButton } from 'components/ZButton';
import { ZIconType } from 'helpers/utility/iconMap';


export function Stores() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const stores = useAppSelector((state: RootState) => state.stores);
	const accounts = useAppSelector((state: RootState) => state.account);
	const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
	const user = useAppSelector((state: RootState) => state.logedinUser);
	const global = useAppSelector((state: RootState) => state.global);

	useEffect(() => {
		Initialise();
	}, [])

	function Initialise() {
		dispatch(getStores({ storeGroupIds: [currentStoreGroupId] }));
		dispatch(getStoreGroups());
	}

	function displayStoreGroups(role: any) {
		let storeGroupName = "";
		if (accounts.storeGroups.length === 0) {
			dispatch(getStoreGroups());
		}
		accounts.storeGroups.forEach((item: any) => {
			if (item.id === role) {
				storeGroupName = item.name;
			}
		});
		return storeGroupName;
	}

	const columnsb = [
		{
			Header: 'Name',
			accessor: 'name',
			defaultCanSort: true,
		},
		{
			Header: 'Status',
			accessor: 'connected',
			Cell: (row: any) => {
				return (
					<>
						{row.cell.row.original.connected === false && <Badge className="me-1 badge-outline-danger">Offline</Badge>}
						{row.cell.row.original.connected === true && <Badge className="me-1 badge-outline-primary">Online</Badge>}
					</>
				);
			}
		},
	];

	function reloadTableRows() {
		dispatch(getStores({ storeGroupIds: [currentStoreGroupId] }));
	}

	function addNewRow() {
		navigate("/app/store/new");
	}

	return (
		<>
			<Title pageTitle="Stores" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table
										pageSize={15}
										isSortable={true}
										pagination={true}
										data={stores.table}
										isSelectable={false}
										isSearchable={true}
										errors={stores.error}
										columns={columnsb}
										loading={stores.loading}
										// addNewRow={addNewRow}
										reloadTableRows={reloadTableRows}
									/>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}